const e = "_segmentedControlItem_1dn2v_1", t = "_iconOnly_1dn2v_7", n = "_disabled_1dn2v_13", o = "_selected_1dn2v_19", c = "_compact_1dn2v_22", d = {
  segmentedControlItem: e,
  iconOnly: t,
  disabled: n,
  selected: o,
  compact: c
};
export {
  c as compact,
  d as default,
  n as disabled,
  t as iconOnly,
  e as segmentedControlItem,
  o as selected
};
//# sourceMappingURL=SegmentedControlItem.module.scss.js.map
